const analyticsTypes = {
  FEATURE_CARD_CLICKED: 'landing_FeatureCard_Click',
};

const analyticsActions = [{
  type: analyticsTypes.FEATURE_CARD_CLICKED,
}];

export {
  analyticsTypes,
  analyticsActions,
};
